import { forLightThemes } from "../externalImages";
import palette from "../light/palette";
import branding from "./branding";
import experimental from "./experimental";
import monaco from "./monaco";
import roles from "./roles";

export default {
	palette,
	externalImages: forLightThemes,
	experimental,
	branding,
	monaco,
	roles,
};
